/**
 * Mixin per il widget anti-bot Cloudflare Turnstile.
 *
 * Uso in un componente:
 *   1. <div ref="turnstile"></div> nel form
 *   2. this.loadTurnstile() nel mounted
 *   3. if (this.turnstileMissing()) { ...mostra errore...; return; } prima dell'invio
 *   4. inviare this.withTurnstileToken(payload)
 *   5. this.resetTurnstile() al termine di OGNI tentativo (il token e' usa e getta)
 *
 * Se VUE_APP_TURNSTILE_SITEKEY non e' configurata il widget non viene caricato
 * e i form continuano a funzionare come prima.
 */
export default {
  data() {
    return {
      turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITEKEY,
      turnstileWidgetId: null,
      turnstileToken: "",
    };
  },
  methods: {
    loadTurnstile: function () {
      if (!this.turnstileSiteKey) {
        console.warn(
          "VUE_APP_TURNSTILE_SITEKEY non configurata: widget anti-bot non caricato"
        );
        return;
      }

      if (window.turnstile) {
        this.renderTurnstile();
        return;
      }

      var existingScript = document.getElementById("cf-turnstile-script");

      if (existingScript) {
        // Un altro componente ha gia' avviato il caricamento dello script.
        existingScript.addEventListener("load", this.renderTurnstile);
        return;
      }

      var script = document.createElement("script");
      script.id = "cf-turnstile-script";
      script.src =
        "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.onload = this.renderTurnstile;
      document.head.appendChild(script);
    },
    renderTurnstile: function () {
      if (!window.turnstile || !this.$refs.turnstile) {
        return;
      }

      if (this.turnstileWidgetId != null) {
        // Gia' renderizzato: evito widget doppi se l'evento load arriva due volte.
        return;
      }

      this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstile, {
        sitekey: this.turnstileSiteKey,
        callback: (token) => {
          this.turnstileToken = token;
        },
        "expired-callback": () => {
          this.turnstileToken = "";
        },
        "error-callback": () => {
          this.turnstileToken = "";
        },
      });
    },
    resetTurnstile: function () {
      this.turnstileToken = "";

      var container = this.$refs.turnstile;

      // A invio riuscito il form sparisce dal DOM: non c'e' piu' nulla da resettare.
      if (
        !window.turnstile ||
        this.turnstileWidgetId == null ||
        !container ||
        !document.body.contains(container)
      ) {
        return;
      }

      try {
        window.turnstile.reset(this.turnstileWidgetId);
      } catch (resetError) {
        console.warn("Reset del widget Turnstile non riuscito", resetError);
      }
    },
    /** true se il widget e' attivo ma l'utente non ha ancora superato la verifica */
    turnstileMissing: function () {
      return Boolean(this.turnstileSiteKey) && this.turnstileToken == "";
    },
    /** aggiunge il token al payload da inviare al backend */
    withTurnstileToken: function (payload) {
      return Object.assign({}, payload, {
        turnstileToken: this.turnstileToken,
      });
    },
  },
};
